import { render, staticRenderFns } from "./Properties.html?vue&type=template&id=6e1513bf&scoped=true&"
import script from "./Properties.ts?vue&type=script&lang=ts&"
export * from "./Properties.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_properties.scss?vue&type=style&index=0&id=6e1513bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1513bf",
  null
  
)

export default component.exports